import { useState, useContext, useRef } from 'react';
import { useDispatch, history } from 'umi';
import { Alert, Spin, Row, Col } from 'antd';
import PcContext from '@/utils/context';
import { message, Typography } from 'iglooform';
import { images } from '@/assets/images';
import { useIntl } from 'react-intl';
import { useSelector } from 'dva';
import { getAgencyInfo } from '@/service';
import { getProducts } from './service';
import { useEffect } from 'react';
import { OtpVerifyModal } from '@/components/otp-verify';
import './home.less';

const CATEGORIES: any = {
  pd: 'Physical Damage',
  motor: 'Third Party Liability',
  pa: 'Personal Accident',
  travel: 'Travel Insurance',
  health: 'Hospital Cash',
};

export default function Products() {
  const token = localStorage.getItem(TOKEN_NAME);
  let { userInfo, currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  const { isPc } = useContext(PcContext);
  const { formatMessage, locale } = useIntl();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [productList, setPorductList] = useState<any>();
  const [otpVerifyVisible, setOtpVerifyVisible] = useState<boolean>(false);
  const userEmail = useRef<string>('');

  const handleCheckStatus = () => {
    setLoading(true);
    getUserInfo();
  };

  const handleGetProducts = () => {
    getProducts().then((res: any) => {
      if (res) {
        setPorductList([{ name: 'pd' }, ...res.list, { name: 'crop' }]);
      }
    });
  };

  const getUserInfo = () => {
    getAgencyInfo()
      .then((info: { userInfo: UserInfo }) => {
        if (info && info.userInfo) {
          dispatch({
            type: 'global/setData',
            payload: {
              userInfo: info.userInfo,
            },
          });
          userEmail.current = info.userInfo.email;
          setOtpVerifyVisible(!info.userInfo.email_verified);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getUserInfo();
    handleGetProducts();

    window.gtag &&
      window.gtag('event', 'home', {
        user_unique_id: JSON.parse(localStorage.getItem('user_info') ?? '{}')
          ?.id,
      });
  }, []);

  return (
    <Spin spinning={loading}>
      <div className="products-container">
        {userInfo?.status === 3 && (
          <Alert
            showIcon={true}
            message={
              <span>
                {formatMessage({
                  id: 'Your profile is being reviewed to be able to sell products.',
                })}{' '}
                <a onClick={handleCheckStatus}>
                  {formatMessage({ id: 'Check Status' })}
                </a>
              </span>
            }
            banner
            className="banner"
          />
        )}
        {userInfo?.status === 2 && (
          <Alert
            showIcon={true}
            message={
              <span>
                {formatMessage({
                  id: 'The account has been deactivated, please contact your up-line for support.',
                })}{' '}
                <a onClick={handleCheckStatus}>
                  {formatMessage({ id: 'Check Status' })}
                </a>
              </span>
            }
            banner
            className="banner"
          />
        )}

        <div className={isPc ? 'category-container' : 'category-container-h5'}>
          <section
            style={isPc ? { marginBottom: '24px' } : { marginBottom: '12px' }}
          >
            <Typography level="h2">
              {formatMessage({ id: 'Categories' })}
            </Typography>
          </section>
          <Row gutter={isPc ? [32, 0] : [12, 0]}>
            {productList?.length > 0 &&
              productList.map(({ name }: any, key: any) => {
                if (!CATEGORIES[name]) return;
                return (
                  <Col
                    span={isPc ? 6 : 12}
                    key={key}
                    className="item"
                    onClick={() => {
                      if (userInfo?.status === 2) {
                        message.error(
                          formatMessage({
                            id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                          }),
                        );
                        return;
                      }
                      if (name === 'crop') {
                        window.open(
                          `${INDEX_INSURANCE_URL}/policies?token=${token}&lang=${locale}`,
                        );
                        return;
                      }
                      history.push(`/home/${name}/product-list`);

                      // event tracking: product view
                      window.gtag('event', 'product_view', {
                        product_name: name,
                        user_unique_id: JSON.parse(
                          localStorage.getItem('user_info') ?? '{}',
                        )?.id,
                      });
                    }}
                    style={{ textAlign: 'center' }}
                  >
                    <div className="product-item">
                      <img
                        alt={name}
                        className="image-item"
                        src={images[name]}
                      />
                    </div>
                    <Typography level="body1">
                      {name === 'crop'
                        ? formatMessage({
                            id: 'Crop Index Insurance',
                          })
                        : formatMessage({ id: CATEGORIES[name] })}
                    </Typography>
                  </Col>
                );
              })}
          </Row>
        </div>
      </div>

      <OtpVerifyModal
        visible={otpVerifyVisible}
        onContinue={() => {
          // route to verify page
          history.replace(
            `/onboarding/otp?email=${
              userEmail.current ?? ''
            }&currentLang=${currentLang}&from=pc`,
          );
          setOtpVerifyVisible(false);
        }}
      />
    </Spin>
  );
}
